import ApplicationEnvironmentJson from 'src/models/application-environment/interfaces/ApplicationEnvironmentJson'
import { Locales } from 'src/i18n'

export default class ApplicationEnvironment {
  domain?: string
  reference: string
  languages: Array<Locales>
  termsAndConditionsUrl: string
  marketingConsentVisible: boolean
  marketingConsentUrl: string | null
  customColorPrimary: string | null
  customColorAccent: string | null
  customColorBody: string | null
  customDarkMode: boolean | null
  customHighContrastMode: boolean | null
  customLogoUrl: string | null
  backgroundImageUrl: string | null

  constructor(
    domain: string | undefined,
    reference: string,
    languages: Array<Locales>,
    termsAndConditionsUrl: string,
    marketingConsentVisible: boolean,
    marketingConsentUrl: string | null,
    customColorPrimary: string | null,
    customColorAccent: string | null,
    customColorBody: string | null,
    customDarkMode: boolean | null,
    customHighContrastMode: boolean | null,
    customLogoUrl: string | null,
    backgroundImageUrl: string | null,
  ) {
    this.domain = domain
    this.reference = reference
    this.languages = languages
    this.termsAndConditionsUrl = termsAndConditionsUrl
    this.marketingConsentVisible = marketingConsentVisible
    this.marketingConsentUrl = marketingConsentUrl
    this.customColorPrimary = customColorPrimary
    this.customColorAccent = customColorAccent
    this.customColorBody = customColorBody
    this.customDarkMode = customDarkMode
    this.customHighContrastMode = customHighContrastMode
    this.customLogoUrl = customLogoUrl
    this.backgroundImageUrl = backgroundImageUrl
  }

  static fromJson(data: ApplicationEnvironmentJson) {
    return new this(
      data.domain,
      data.reference,
      data.languages,
      data.termsAndConditionsUrl,
      data.marketingConsentVisible,
      data.marketingConsentUrl,
      data.customColorPrimary,
      data.customColorAccent,
      data.customColorBody,
      data.customDarkMode,
      data.customHighContrastMode,
      data.customLogoUrl,
      data.backgroundImageUrl,
    )
  }
}
